import { render } from "./AppLoginView.vue?vue&type=template&id=473a0e3f&scoped=true"
import script from "./AppLoginView.vue?vue&type=script&lang=js"
export * from "./AppLoginView.vue?vue&type=script&lang=js"

import "./AppLoginView.vue?vue&type=style&index=0&id=473a0e3f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-473a0e3f"]])

export default __exports__